/* globals qmean */

export default function initInputClear () {
  const $blocks = $('.input-clear')
  if (typeof qmean !== 'undefined') {
    qmean.labels.loading = 'chargement...'
  }
  $blocks.each((index, inputClear) => {
    const $inputClear = $(inputClear)
    const $input = $inputClear.parents('form').find('input')
    console.log('input clear', $input.val())

    /* if ($input.val()) {
      $inputClear.show()
    } else {
      $inputClear.hide()
    } */

    setTimeout(() => {
      if ($input.val()) {
        $inputClear.show()
      } else {
        $inputClear.hide()
      }
    }, 1000)

    $input.on('input', () => {
      // console.log('change')
      if ($input.val()) {
        $inputClear.show()
      } else {
        $inputClear.hide()
      }
    })

    $inputClear.click(() => {
      $input.val('')
      $input.trigger('input')
    })
  })
}
